export default __webpack_public_path__ + "static/media/resume.d6255aa3.pdf";